
/**
 * 从一个url(https://hosyname/path?query)中字符串中取query前面的部分
 *
 * @param {string} url url 字符串
 * @return query前面的部分   https://hosyname/path
 */
export default function extractPathname(url) {
    if (!url) {
        return '';
    }

    const queryStart = url.indexOf('?');

    if (queryStart === -1) {
        return url;
    }

    return url.slice(0, queryStart);

}
